export default __webpack_public_path__ + "static/media/phone.3de1c224.png";